import { CancelOutlined } from "@mui/icons-material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { devLog } from "utils/devLog";

const searchTypeMap = new Map();

export default function MMCMemberSearchForm(props) {
  const NAME = "NAME";
  const MEMBER_NUMBER = "MEMBER_NUMBER";
  const LAST8_VIN = "LAST8_VIN";

  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(
    props.currState.MemberLookup?.firstName || props.currState.FirstName || "",
  );
  const [lastName, setLastName] = useState(props.currState.MemberLookup?.lastName || props.currState.LastName || "");
  const [phoneNumber, setPhoneNumber] = useState(
    props.currState.MemberLookup?.phoneNumber || props.currState.Number || "",
  );
  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber || "");
  const [last8Vin, setLast8Vin] = useState(props.currState.MemberLookup.last8Vin || "");

  const [searchTypes, setSearchTypes] = useState([
    { key: NAME, value: t("description.Name") },
    { key: LAST8_VIN, value: t("ATF.ContractSearch.DropdownOptions3") },
    { key: MEMBER_NUMBER, value: t("FIMC.ContractSearch.DropdownOptions1") },
  ]);

  const [selectedSearchTypes, setSelectedSearchTypes] = useState(props.currState.MemberLookup?.searchType || NAME);

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [lessThan7, setLessThan7] = useState(false);

  useEffect(() => {
    devLog(selectedSearchTypes);
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
    setMemberNumber(memberNumber);
    setLast8Vin(last8Vin);
  }, [selectedSearchTypes]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (memberNumber.length < 7 && selectedSearchTypes === MEMBER_NUMBER) {
      setLessThan7(true);
      return;
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        memberNumber: memberNumber,
        last8Vin: last8Vin,
        searchType: selectedSearchTypes,
      });
    }
    return false;
  };

  const memberNumberLen = (e) => {
    if (e.target.value.length > 7) {
      e.target.value = e.target.value.slice(0, -1);
    }
  };

  const last8VinLen = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
    }
  };

  const windowWidth = () => {
    if (width < 720) {
      return "group-1 group-v2 input-v2";
    } else {
      return "group-1";
    }
  };

  const windowWidth2 = () => {
    if (width < 720) {
      return "label label-v2";
    } else {
      return "label";
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key == selectedSearchTypes)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchTypes}
                    onClick={(e) => setSelectedSearchTypes(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* <div className="searchType">{t("description.Name")}</div> */}

          {/*Name (first name)*/}
          {selectedSearchTypes === NAME && (
            <>
              {/* <div className="group-1">
                <div className="label"> */}

              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="text"
                  placeholder="ex: JOHN"
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {selectedSearchTypes === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="text"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {selectedSearchTypes === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("FIMC.ContractSearch.DropdownOptions5")}:</div>
                <input
                  type="tel"
                  name="phoneNumber"
                  className="input form-control required"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          {selectedSearchTypes === MEMBER_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("FIMC.ContractSearch.DropdownOptions1")}:</div>
                <input
                  type="number"
                  placeholder="ex:1234567"
                  name="memberNumber"
                  className="input form-control required"
                  value={memberNumber}
                  onChange={(e) => {
                    memberNumberLen(e);
                    setMemberNumber(e.target.value?.trim() || "");
                  }}
                  required
                />
              </div>
              {lessThan7 && <Alert severity="error">{t("description.MembershipNumberInputErrorMsg")}</Alert>}
            </>
          )}

          {selectedSearchTypes === LAST8_VIN && (
            <>
              {/* <div className="group-1">
                <div className="label"> */}

              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("ATF.ContractSearch.DropdownOptions3")}:</div>
                <input
                  type="text"
                  name="last8Vin"
                  className="input form-control required"
                  value={last8Vin}
                  maxLength={8}
                  onChange={(e) => {
                    last8VinLen(e);
                    setLast8Vin(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
